<mat-toolbar class="one-header" [ngClass]="{'in-detail': isInDetail == true}">
    <mat-toolbar-row class="header-row">
        <h2 class="title">Quản lý nhóm đề xuất</h2>
        <div class="side d-flex">
            <div class="input-group">
                <span class="icon">
                    <i class="fa fa-search"></i>
                </span>
                <input type="text" class="form-control" placeholder="{{text.GROUP_SEARCH_TEXT}}">
            </div>
            <button mat-raised-button color="warn" (click)="openCreateForm()">{{text.CREATE_NEW_GROUP}}</button>
            <button class="more" mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_horiz</mat-icon>
            </button>
            <mat-menu #menu="matMenu" xPosition="before">
                <button mat-menu-item (click)="uploader.click()">
                    <mat-icon>arrow_upward</mat-icon>
                    <span>Upload nhóm đề xuất</span>
                </button>
                <button mat-menu-item (click)="downloadExampleRequest()">
                    <mat-icon>attachment</mat-icon>
                    <span>Xem file đề xuất mẫu</span>
                </button>
            </mat-menu>
            <input hidden type="file" #uploader accept=".xls,.xlsx" (change)="uploadFile($event)" />
        </div>
    </mat-toolbar-row>
    <mat-toolbar-row class="header-row overflow-x">
        <nav mat-tab-nav-bar class="one-tab-nav-bar">
            <a mat-tab-link class="one-tab" [active]="isFilterAll" (click)="onFilter('')">{{text.GROUP_FILTER.ALL}}</a>
            <a mat-tab-link class="one-tab" [active]="isFilterActive"
                (click)="onFilter('ENABLED')">{{text.GROUP_FILTER.ACTIVE}}</a>
            <a mat-tab-link class="one-tab" [active]="isFilterInactive"
                (click)="onFilter('DISABLED')">{{text.GROUP_FILTER.INACTIVE}}</a>
        </nav>
    </mat-toolbar-row>
</mat-toolbar>
